import React from 'react';
import {
  Typography,
  Box,
  Stack,
  Skeleton,
} from '@mui/material';
import {
  BackButton, ContextMenu, ContextMenuButton, ContextMenuItem,
} from '@marageti/z4-lib';
import { UserStatus } from '@marageti/z4-sdk/lib/auth';
import { StatusItemProps, ViewProps } from './types';
import { peopleStatusIcons } from '../status-icons';
import SubNavigation from '../sub-navigation';
import { getAgentRoles } from '../../utils/helpers';

const StatusItem = ({ onClick, status }: StatusItemProps) => (
  <ContextMenuItem onClick={() => onClick(status)}>
    <Stack spacing={1.5} direction="row">
      {peopleStatusIcons[status].icon}
      <Typography variant="h4">
        {peopleStatusIcons[status].displayName}
      </Typography>
    </Stack>
  </ContextMenuItem>
);

const AgentSubNavigationView = ({
  contextMenuAnchor,
  contextMenuOpen,
  onClickNewStatus,
  setContextMenuAnchor,
  agent,
  tabs,
}: ViewProps) => (
  <SubNavigation
    startAdornment={(
      <BackButton
        aria-label="back to partners"
        defaultPath="/partners"
        edge="start"
      />
      )}
    profile={{
      primary: agent?.fullName ? (
        <Stack component="span" direction="row" alignItems="center" spacing={1}>
          <Typography
            component="span"
            variant="body1"
            fontWeight="bold"
          >
            {agent?.fullName}
          </Typography>
          <Box
            component="span"
            display="flex"
          >
            {agent.userInfo[0]?.status && (
              <ContextMenuButton
                id="agent-status-context-button-id"
                onClick={(e) => setContextMenuAnchor(e.currentTarget)}
                open={contextMenuOpen}
                menuId="agent-status-context-button-menu-id"
                size="small"
              >
                {peopleStatusIcons[agent.userInfo[0]?.status].icon}
              </ContextMenuButton>
            )}
            <ContextMenu
              anchorEl={contextMenuAnchor}
              buttonId="agent-status-context-menu-button-id"
              id="agent-status-context-menu-id"
              onClose={() => setContextMenuAnchor(null)}
              open={contextMenuOpen}
            >
              { (Object.keys(UserStatus) as Array<keyof typeof UserStatus>).map((key) => (
                <StatusItem
                  key={key}
                  onClick={onClickNewStatus}
                  status={key as UserStatus}
                />
              ))}
            </ContextMenu>
          </Box>
        </Stack>
      ) : <Skeleton width={250} height={34} />,
      secondary: agent ? [getAgentRoles(agent), agent.title].filter(Boolean).join(' • ') : <Skeleton width={150} />,
    }}
    tabs={tabs}
  />
);

export default AgentSubNavigationView;
